import React, { useState } from 'react';

import { addStore } from 'client/shared/react-util';
import { FieldFactory } from 'client/shared/components';
import { toast } from 'react-toastify';
import { inject, observer } from 'mobx-react';


const MoodsGenreForm = ({artist, artistStore, formStore, genreStore}) => {
    const FieldWithStore = addStore(FieldFactory, {formStore});
    const [mood1, setMood1] = useState('');
    const moodList = artist.moods.map((m) => m.name);

    const Field = (props) => (
        <FieldFactory
            noFieldClass
            item={ artist }
            formStore={ formStore }
            { ...props }
        />
    );

    const saveArtist = async () => {
        try {
           await artistStore.saveArtist(artist)
           toast.success(`${artist.name}'s genre was updated successfully.`);
        } catch (err) {
            toast.error(`An error occured while saving ${artist.name}.`);
            console.error('[ERROR SAVING ARTIST]', err);
        }
    }
    const handleChangeGenre = (key, value) => {
        artist.genreID = value;
        artist.genre = genreStore.items.find(g=>g.id === artist.genreID).label

    }

    const addMood = async (mood1) => {
    try {
        await artistStore.addMood(mood1, artist);
        await artistStore.saveArtist(artist);
        toast.success(`${artist.name}'s mood was added successfully.`);
        setMood1('');
    } catch (err) {
        toast.error(`An error occured while saving ${artist.name}.`);
        console.error('[ERROR SAVING ARTIST]', err);
    }
}
    const deleteMood = async (mood) => {
        try {
            await artistStore.deleteMoodByName(mood, artist);
            await artistStore.saveArtist(artist);
            toast.success(`${artist.name}'s mood was deleted successfully.`);
        } catch (err) {
            toast.error(`An error occured while saving ${artist.name}.`);
            console.error('[ERROR SAVING ARTIST]', err);
        }
    }

    return (
        <div>
            <h4>Current Moods</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '1rem' }}>
                {moodList.length ? (
                    moodList.map((mood, index) => (
                        <span
                            key={`${mood}-${index}`}
                            className="mood-badge"
                        >
                            <span>{mood}</span>
                            <span
                                aria-label={`Remove ${mood}`}
                                title={`Remove ${mood}`}
                                onClick={() => deleteMood(mood)}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '1.1rem',
                                    height: '1.1rem',
                                    borderRadius: '50%',
                                    background: 'rgba(0, 0, 0, 0.08)',
                                    color: '#6c757d',
                                    fontSize: '0.75rem',
                                    fontWeight: '700',
                                    lineHeight: 1,
                                    transition: 'all 0.2s ease',
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = '#dc3545';
                                    e.target.style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(0, 0, 0, 0.08)';
                                    e.target.style.color = '#6c757d';
                                }}
                            >
                                ×
                            </span>
                        </span>
                    ))
                ) : (
                    <h6>No moods have been added.</h6>
                )}
            </div>
            <div className="grid-x">
                <div className="small-6 large-4 cell">
                    <FieldWithStore
                        item={artist}
                        fieldKey="artist.mood1"
                        defaultValue={mood1}
                        onChange={(key, val) => setMood1(val)}
                    />
                    <button onClick={() => addMood(mood1)} className="button neo margin-right-3">Add Mood</button>
                </div>

                <div className="small-6 large-4 cell">
                    <span style={{paddingBottom: '8px', marginBottom: '16px'}}>
                        <Field
                            item={ artist }
                            optionsStore={ genreStore }
                            defaultValue={genreStore.items.find(g=>g.id === artist.genreID)?.label}
                            onChange={(key, value) => handleChangeGenre(key, value)}
                            fieldKey="artist.genre"
                            placeholder="Select Genre"
                            label='Genre'
                        />
                    </span>
                    <button onClick={saveArtist} className="button neo margin-right-3">Update Genre</button>
                </div>
            </div>

        </div>
    );
};

// const saveGenre = async (genre, artist) => {
//     let moodArray = [mood1, mood2];
//     try {
//         await artistStore.setMoodList(moodArray, artist);
//         toast.success(`${artist.name}'s moods were updated successfully.`);
//     } catch (err) {
//         toast.error(`An error occured while saving ${artist.name}.`);
//         console.error('[ERROR SAVING ARTIST]', err);
//     }
// }



const injectWithStores = inject('genreStore', 'artistStore');

export default injectWithStores(
    observer(({artist, artistStore, genreStore, formStore}) => {
        return (
            <MoodsGenreForm artist={artist} artistStore={artistStore} formStore={formStore} genreStore={genreStore} />
        )
    }))
